import { Form } from 'formik';
import styled from 'styled-components';
export const StyledForm = styled(Form) `
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
`;
